export default __webpack_public_path__ + "static/insfocus_small-2-aecdbd419d9d31b5b7e5d3d9eea9de1c.png";